import {MeasurementPrecisionTypes} from "@model";
import {milisecondsToPrecision} from "./miliseconds-to-precision";

export function stringTimeToPrecision(time: string|undefined, measurementPrecisionType: MeasurementPrecisionTypes): string {
    if (!time) return '';
    const [hh, mm, ssMs] = time.split(':');
    if (!ssMs) return "";
    let [ss, ms = '000'] = ssMs.split('.');

    ms = ms.padEnd(3, '0');

    const milliseconds = (parseInt(hh) * 3600000) + (parseInt(mm) * 60000) + (parseInt(ss) * 1000) + parseInt(ms.padEnd(3, '0'));

    return milisecondsToPrecision(milliseconds, measurementPrecisionType);
}